module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range-slider",
    class: ("range-slider--" + _vm.orientation)
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "range-slider__control range-slider__control--min",
    on: {
      "mousedown": _vm.mousedownHandler,
      "touchstart": _vm.touchstartHandler
    }
  }, [_c('span', {
    staticClass: "range-slider__tooltip range-slider__tooltip--top",
    domProps: {
      "innerHTML": _vm._s(_vm.formatValue(_vm.VALUE_MIN))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "range-slider__control range-slider__control--max",
    on: {
      "mousedown": _vm.mousedownHandler,
      "touchstart": _vm.touchstartHandler
    }
  }, [_c('span', {
    staticClass: "range-slider__tooltip range-slider__tooltip--bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.formatValue(_vm.VALUE_MAX))
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range-slider__track"
  }, [_c('div', {
    staticClass: "range-slider__filled"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42821aec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/RangeSlider.vue
// module id = 6
// module chunks = 1